import React from 'react';
import Tooltip from '@dealroadshow/uikit/core/components/Tooltip';
import styles from './leagueTablePage.scss';

interface ICellProps {
  cellData: string,
}

export const dealCountCellCallback = (cellProps: ICellProps) => (
  <Tooltip content="Deal Count">
    { cellProps.cellData }
  </Tooltip>
);

export const typeCellCallback = (cellProps: ICellProps) => (
  <span className={ styles.typeCell }>
    { cellProps.cellData === 'underwriter' ? 'Underwriter' : 'Rating Agency' }
  </span>
);
